import React from 'react';

export const P = ({children, link}) => (<p><a href={link} target="_blank" rel="noopener noreferrer">{children}</a></p>)

